import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col w-full gap-04" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "pad-m h4" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = { class: "w-full es-appointment rnd-xl" }
const _hoisted_6 = { class: "w-full flex-row gap-10 mright-10" }
const _hoisted_7 = { class: "accordion-header-title gap-10 flex-1" }
const _hoisted_8 = { class: "font-size-14" }
const _hoisted_9 = { class: "font-m text-overflow-ellipsis" }
const _hoisted_10 = { class: "font-m text-overflow-ellipsis" }
const _hoisted_11 = { class: "font-m text-overflow-ellipsis" }
const _hoisted_12 = { class: "font-size-16 mtop-08 mbottom-08" }
const _hoisted_13 = { class: "flex-col gap-05" }
const _hoisted_14 = { class: "align-l" }
const _hoisted_15 = { class: "font-mBold" }
const _hoisted_16 = { class: "align-l" }
const _hoisted_17 = { class: "font-mBold" }
const _hoisted_18 = { class: "align-l" }
const _hoisted_19 = { class: "font-mBold" }
const _hoisted_20 = { class: "align-l" }
const _hoisted_21 = { class: "font-mBold" }
const _hoisted_22 = { class: "align-l" }
const _hoisted_23 = { class: "font-mBold" }
const _hoisted_24 = { class: "align-l" }
const _hoisted_25 = { class: "font-mBold" }
const _hoisted_26 = { class: "align-l" }
const _hoisted_27 = { class: "font-mBold" }
const _hoisted_28 = {
  key: 0,
  class: "mtop-10 tooltip"
}
const _hoisted_29 = {
  key: 0,
  class: "tooltiptext max-w-500 font-s"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "txt-grey-64 pad-xl" }

import { PaginatedUserAppointmentsResponse, UserAppointmentResponse, UserAppointmentStatusEnum } from '@/apiGenerate/medserver';
import EsPaginator from '@/components/share/esPaginator.vue';
import { BadgeSeverity, DateFormat, MIDNIGHT_TIME_SHORT } from '@/models/share.model';
import { format } from 'date-fns';
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel, Badge, BadgeProps, useToast } from 'primevue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { PageableDefaultForUserAppointments } from '@/models/share.model';
import { useRouter } from 'vue-router';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { toastWarn } from '@/utils/toast-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAppointmentsContent',
  props: {
    title: {},
    paginatedUserAppointmentsResponse: {},
    isPast: { type: Boolean }
  },
  emits: ['reloadPast', 'reloadComming'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const router = useRouter();
const currentEntryStore = useCurrentEntryStore();
const toast = useToast();

const emits = __emit;
const paginatorLoading = ref<boolean>(false);

const disabledMoveAppointment = computed(() => {
  return currentEntryStore.moveAppointmentFromPatient || currentEntryStore.moveAppointmentFromCalendar;
});

const formatDate = (dateTime: string) => format(new Date(dateTime), DateFormat.FRONT_LONG);
const formatTime = (dateTime: string) => format(new Date(dateTime), DateFormat.TIME_SMALL);

const statusToSeverity: (status: UserAppointmentStatusEnum) => BadgeProps["severity"]  = (status: UserAppointmentStatusEnum) => {
    switch (status) {
        case UserAppointmentStatusEnum.Honoured:
            return BadgeSeverity.Success;
    
        case UserAppointmentStatusEnum.NotHonoured:
            return BadgeSeverity.Danger;

        case UserAppointmentStatusEnum.Scheduled: 
            return BadgeSeverity.Info;
        
        case UserAppointmentStatusEnum.ToValidate:
            return BadgeSeverity.Warn;

        case UserAppointmentStatusEnum.WaitingRoom:
            return BadgeSeverity.Info;

        case UserAppointmentStatusEnum.Cancelled:
            return BadgeSeverity.Contrast;

        default:
            return null;
    }
}

const handleNextPage = () => {
    emits(props.isPast ? 'reloadPast': 'reloadComming', props.paginatedUserAppointmentsResponse.pageable.start + props.paginatedUserAppointmentsResponse.pageable.limit);
}

const handlePreviousPage = () => {
    emits(props.isPast ? 'reloadPast': 'reloadComming', props.paginatedUserAppointmentsResponse.pageable.start - props.paginatedUserAppointmentsResponse.pageable.limit);
}

const getTime = (dateTime: string) => {
    return formatTime(dateTime) === MIDNIGHT_TIME_SHORT ? t("patient.appointments.withoutAppointment") : formatTime(dateTime)
}

async function accessCalendar() {
    if (disabledMoveAppointment.value) {
        toastWarn(toast, {
            summary: t('common.toast.warning'),
            detail: t('error.MOVE_APPOINTMENT_IN_PROGRESS')
        });
    } else {
        currentEntryStore.closePatientModal();
        currentEntryStore.setCurrentPatientCalendar(currentEntryStore.modalPatient);
        router.push({
            name: "calendar"
        });
    }
}

const getIconAction = () => {
    return {
      codeAction: 'es-button-icon-action',
      icon: 'calendar',
      pathIcon: 'settings'
    };
}

const moveAppointment = async (appointment: UserAppointmentResponse) => {
    if (disabledMoveAppointment.value) {
        toastWarn(toast, {
            summary: t('common.toast.warning'),
            detail: t('error.MOVE_APPOINTMENT_IN_PROGRESS')
        });
    } else {
        await currentEntryStore.setMoveAppointmentFromPatient(appointment, currentEntryStore.currentPatient);
        currentEntryStore.setCurrentPatientCalendar(currentEntryStore.modalPatient);
        router.push({
            name: "calendar"
        });
        currentEntryStore.closePatientModal();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (!props.isPast && !disabledMoveAppointment.value)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "pad-m",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (accessCalendar()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "plus",
                styles: "size-l main-l"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.paginatedUserAppointmentsResponse && _ctx.paginatedUserAppointmentsResponse.totalRowCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Accordion), { value: "0" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedUserAppointmentsResponse.rows, (row, index) => {
                  return (_openBlock(), _createBlock(_unref(AccordionPanel), {
                    key: row.uuid,
                    value: row.uuid,
                    class: _normalizeClass(index === _ctx.paginatedUserAppointmentsResponse.rows.length - 1  ? 'last-item' : '')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AccordionHeader), null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("h3", _hoisted_8, _toDisplayString(formatDate(row.dateTime)) + " - " + _toDisplayString(getTime(row.dateTime)), 1),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(row.healthProFullName), 1),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(row.type) + ": " + _toDisplayString(row.duration) + "' ", 1),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(row.appointmentInfo), 1)
                            ]),
                            _createVNode(_unref(Badge), {
                              severity: statusToSeverity(row.status)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)(`common.appointment.status.${row.status}`)), 1)
                              ]),
                              _: 2
                            }, 1032, ["severity"])
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(AccordionContent), null, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(t)("patient.appointments.appointmentDetails")) + " :", 1),
                          _createElementVNode("dl", _hoisted_13, [
                            _createElementVNode("dt", _hoisted_14, _toDisplayString(_unref(t)("patient.appointments.patientFullName")), 1),
                            _createElementVNode("dd", _hoisted_15, _toDisplayString(row.patientFullName), 1),
                            _createElementVNode("dt", _hoisted_16, _toDisplayString(_unref(t)("patient.appointments.healthProFullName")), 1),
                            _createElementVNode("dd", _hoisted_17, _toDisplayString(row.healthProFullName), 1),
                            _createElementVNode("dt", _hoisted_18, _toDisplayString(_unref(t)("patient.appointments.type")), 1),
                            _createElementVNode("dd", _hoisted_19, _toDisplayString(row.type), 1),
                            _createElementVNode("dt", _hoisted_20, _toDisplayString(_unref(t)("patient.appointments.date")), 1),
                            _createElementVNode("dd", _hoisted_21, _toDisplayString(formatDate(row.dateTime)), 1),
                            _createElementVNode("dt", _hoisted_22, _toDisplayString(_unref(t)("patient.appointments.time")), 1),
                            _createElementVNode("dd", _hoisted_23, _toDisplayString(getTime(row.dateTime)), 1),
                            _createElementVNode("dt", _hoisted_24, _toDisplayString(_unref(t)("patient.appointments.appointmentInfo")), 1),
                            _createElementVNode("dd", _hoisted_25, _toDisplayString(row.appointmentInfo ?? "-"), 1),
                            _createElementVNode("dt", _hoisted_26, _toDisplayString(_unref(t)("patient.appointments.duration")), 1),
                            _createElementVNode("dd", _hoisted_27, _toDisplayString(row.duration) + " " + _toDisplayString(_unref(t)("patient.appointments.minutes")), 1)
                          ]),
                          (_unref(UserAppointmentStatusEnum).Scheduled === row.status)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_component_es_button, {
                                  disabled: disabledMoveAppointment.value,
                                  "icon-content-button": getIconAction(),
                                  widthClass: 'w-full',
                                  class: "es-modal-header-button row",
                                  label: _unref(t)('calendar.label.move.action'),
                                  onClick: ($event: any) => (moveAppointment(row)),
                                  "is-primary": true,
                                  "icon-styles": "img-white"
                                }, null, 8, ["disabled", "icon-content-button", "label", "onClick"]),
                                (disabledMoveAppointment.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(t)('calendar.label.move.disabled')), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value", "class"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          (_ctx.paginatedUserAppointmentsResponse.totalRowCount > _unref(PageableDefaultForUserAppointments).limit)
            ? (_openBlock(), _createBlock(EsPaginator, {
                key: 0,
                class: "mtop-04 w-full",
                currentRef: 'paginator-timeslot-top',
                pageable: _ctx.paginatedUserAppointmentsResponse.pageable,
                total: _ctx.paginatedUserAppointmentsResponse.totalRowCount,
                loading: paginatorLoading.value,
                onPrevPage: handlePreviousPage,
                onNextPage: handleNextPage
              }, null, 8, ["pageable", "total", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('patient.appointments.empty')), 1)
        ]))
  ]))
}
}

})